import { Container, ThemeProvider } from '@mui/material';
import { createTheme } from "@mui/material/styles";
import * as React from 'react';
import Board from '../kanban-applications/components/Board';

const applicationsTheme = createTheme({
    components: {
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingTop: '10px !important',
                },
            },
        },
    },
});

export function DisplayApplicationsOnDeJob({
    deJobId,
}: {
    deJobId: number;
}) {

    return <ThemeProvider theme={applicationsTheme}>
        <Container maxWidth={false} disableGutters>
            <Board jobId={deJobId} />
        </Container>
    </ThemeProvider>
}